import graphql from "babel-plugin-relay/macro";

export const InspectionListQuery = graphql`
  query QueriesInspectionListQuery($userId: ID) {
    allInspectionfields(inspector_Isnull: false, inspector_User: $userId) {
      totalCount
      edgeCount
      edges {
        node {
          id
          externalId
          state
          year
          member {
            id
            name
          }
          managementPackageVariant {
            code
          }
          field {
            member {
              id
              name
            }
            geometry
          }
          periodEnd
          periodStart
          assignedDate
          plannedDate
          latestInspection {
            lastModified
            approvedDate
            retryDate
            rejectedDate
          }
          ...InspectionFieldCard
          ...QueriesInspectionListUpdatable
        }
      }
    }
  }
`;

export const MutationInFlightQuery = graphql`
  mutation QueriesInspectionListMutation(
    $id: ID!
    $state: InspectionfieldStateEnum!
    $timestamp: Float!
  ) {
    modifyInspectionfieldDate(
      input: { id: $id, timestamp: $timestamp, state: $state }
    ) {
      inspectionfield {
        id
        state
        plannedDate
        latestInspection {
          lastModified
          approvedDate
          retryDate
          rejectedDate
        }
      }
    }
  }
`;

export const InspectionListUpdatableFragmentQuery = graphql`
  fragment QueriesInspectionListUpdatable on InspectionfieldNode @updatable {
    state
    plannedDate
  }
`;
